import React from "react";
import { useAuth } from './AuthContext';
import { useNavigate, Link } from 'react-router-dom';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <nav className="w-full bg-white shadow-sm py-3 px-6 flex items-center justify-between">
      <Link to="/" className="font-bold text-xl text-indigo-700">PowerShell GUI Builder</Link>
      <div className="flex items-center gap-6">
        {!user && (
          <>
            <Link to="/about" className="text-gray-700 hover:text-indigo-600 text-sm">About</Link>
            <Link to="/features" className="text-gray-700 hover:text-indigo-600 text-sm">Features</Link>
            <Link to="/pricing" className="text-gray-700 hover:text-indigo-600 text-sm">Pricing</Link>
          </>
        )}
        {user && (
          <>
            <Link to="/dashboard" className="text-gray-700 hover:text-indigo-600 text-sm">Dashboard</Link>
            <Link to="/builder" className="text-gray-700 hover:text-indigo-600 text-sm">Create GUI</Link>
          </>
        )}
        {user ? (
          <>
            <span className="text-gray-700 text-sm">{user.email}</span>
            <button
              onClick={() => { logout(); navigate('/'); }}
              className="bg-red-50 text-red-700 px-3 py-1 rounded hover:bg-red-100 text-sm"
            >
              Logout
            </button>
          </>
        ) : (
          <>
            <Link to="/login" className="bg-indigo-50 text-indigo-700 px-3 py-1 rounded hover:bg-indigo-100 text-sm">Login</Link>
            <Link to="/register" className="bg-indigo-600 text-white px-3 py-1 rounded hover:bg-indigo-700 text-sm">Register</Link>
          </>
        )}
      </div>
    </nav>
  );
} 